import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "divide-y divide-accent",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "flex-grow min-w-0" }
const _hoisted_3 = { class: "block" }
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col gap-2",
  "aria-hidden": "true"
}
const _hoisted_6 = { class: "flex-grow min-w-0" }
const _hoisted_7 = { class: "block" }


export default /*@__PURE__*/_defineComponent({
  __name: 'SkeletonRows',
  props: {
    rows: { default: 5 },
    variant: { default: 'plain' },
    meta: { default: 'sm' },
    align: { default: 'center' }
  },
  setup(__props: any) {

/**
 * Placeholder list rows matching the two admin list shapes:
 *
 * - `plain`: `divide-y` rows (`py-3`, title line + meta line + action),
 *   as used by the entities / invites / AMA indexes.
 * - `card`: draggable-style rows (`bg-accent px-3 py-2`, drag handle,
 *   title line + `text-xs` meta line), as used by talks / uses.
 */


const widths = ['w-2/5', 'w-1/4', 'w-1/3', 'w-1/2']

return (_ctx: any,_cache: any) => {
  const _component_AdminSkeleton = _resolveComponent("AdminSkeleton")!

  return (__props.variant === 'plain')
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: i,
            class: _normalizeClass(["py-3 flex gap-4", __props.align === 'center' ? 'items-center' : 'items-start'])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_AdminSkeleton, {
                  class: _normalizeClass(["bg-accent", widths[(i - 1) % widths.length]])
                }, null, 8, ["class"])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(__props.meta === 'sm' ? 'text-sm' : 'text-xs mt-1')
              }, [
                _createVNode(_component_AdminSkeleton, { class: "bg-accent w-1/2" })
              ], 2)
            ]),
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_AdminSkeleton, { class: "bg-accent w-10" })
            ])
          ], 2))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: i,
            class: "flex items-center gap-3 bg-accent px-3 py-2"
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-muted select-none" }, [
              _createElementVNode("span", { class: "invisible" }, "⋮⋮")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_AdminSkeleton, {
                  class: _normalizeClass(["bg-muted/20", widths[(i - 1) % widths.length]])
                }, null, 8, ["class"])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(__props.meta === 'sm' ? 'text-sm' : 'text-xs')
              }, [
                _createVNode(_component_AdminSkeleton, { class: "bg-muted/20 w-1/3" })
              ], 2)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(__props.meta === 'sm' ? 'text-sm' : 'text-xs')
            }, [
              _createVNode(_component_AdminSkeleton, { class: "bg-muted/20 w-8" })
            ], 2)
          ]))
        }), 128))
      ]))
}
}

})